export default "__VITE_ASSET__CB7Fk$h8__"